export const mxLinuxDevices = require("./mx-linux_overlay-fs8.png");
export const logos = require("./image.png");
